import { render } from "./SpotsShow.vue?vue&type=template&id=2bfd4c94"
import script from "./SpotsShow.vue?vue&type=script&lang=js"
export * from "./SpotsShow.vue?vue&type=script&lang=js"

import "./SpotsShow.vue?vue&type=style&index=0&id=2bfd4c94&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__